import { KeyValue } from './types/KeyValue';

// 棚種別
export const shelf_type = {
  header: 1,
  shelf: 2,
  layout_divisiton: 3,
  fragment: 4,
  footer: 5,
  full_justify_buttons: 6,
  left_button: 7,
  center_button: 8,
  right_button: 9,
  justify_buttons: 10,
  left_and_right_alignment_buttons: 11,
  left_and_center_alignment_buttons: 12,
  account_transfer_info: 31,
  bank_account: 32,
  ja_bank: 33,
  account_holder: 34,
  customer_upload: 35,
};

// 同意文の種別
// 1.マイページ開設
// 2.個人情報取り扱い
// 3.反社会的勢力でない
export const clauses_type_list = [1, 2, 3];
// True,False
export const checked_on = true;
export const checked_off = false;

// 商品選択画面のパス
export const product_image_path = `${process.env.MIX_MOCK_FILEURL}/img/product_list/`;
// 商品選択画面の画像パス
export const overview_step_img = `${process.env.MIX_MOCK_FILEURL}/img/product_list/overview_step.png`;
export const ahead_step_img = `${process.env.MIX_MOCK_FILEURL}/img/product_list/ahead_step.png`;
export const main_step_img = `${process.env.MIX_MOCK_FILEURL}/img/product_list/main_step.png`;
export const contract_step = `${process.env.MIX_MOCK_FILEURL}/img/product_list/contract_step.png`;
export const contract_step_icon = `${process.env.MIX_MOCK_FILEURL}/img/product_list/contract_step_icon.png`;
export const file_icon = `${process.env.MIX_MOCK_FILEURL}/img/product_list/file_icon.png`;

// 詳細画面のPDFパス
export const pdf_viewer = `/images/sample_pdf.pdf`;

// 一時変数の初期値
export const tmp_init = {
  key: '',
  pb_id: 0,
  cb_id: 0,
  fm_id: 0,
  is_send_parent: false,
  fm_display_name: '',
  required_mark: false,
  field_column_name: '',
  fm_type: '',
  placeholder: '',
  function: '',
  message: '',
  value: '',
  prefix: '',
  suffix: '',
  sources: [{ key: '', value: '', checked: false }],
  help_msg: '',
  disabled: false,
  bold: false,
  color: '',
  dialog: false,
  dialog_title: '',
  dialog_msg: '',
  dialog_is_open: false,
  input_assistance: '',
  maxlength: 0,
  file_shelf_cd: '',
  default_value: 0,
  readonly: false,
};

// 応答ダイアログの初期値
export const dialog_init = {
  is_confirm: false,
  show: false,
  title: '',
  body: '',
};

// 応答ダイアログの種別
export const dialog_type = {
  confirm: '1',
  yes_no: '2',
};

// 応答ダイアログのファンクション位置
export const dialog_function = {
  confirm: 0,
  yes: 1,
  no: 2,
};

// pdfのアイコン
export const pdf_icon = `${process.env.MIX_MOCK_URL}/images/pdf_icon.png`;

// APIからの応答種別
export const api_response_type = {
  page_transition: 0, // 画面遷移
  dialog: 1, // ダイアログ
  validation: 2, // バリデーション
  list: 3, // リスト
  auto_input: 4, // 指定項目の自動表示
  auto_input_all: 5, // 全画面に対して自動表示
  transition_to_list: 9, // 一覧画面に遷移
  transition_to_mypage: 10, // マイページ開設同意確認画面への遷移
  download: 11, // pdfダウンロード
  transition_to_mypage_complete: 12, // マイページ開設完了画面への遷移
  transition_to_login: 22, // ログイン画面(マイペ―ジ)への遷移
  transition_to_password_regist: 23, // パスワード設定画面に遷移
};

/**
 * 値変換種別
 */
export const convert_types = {
  add_comma: 'addComma',
  change_numeric: 'cngNumeric',
  change_rational_number: 'changeRationalNumber',
  change_zenkaku_kana: 'cngZenkakuKana',
  change_hankaku_kana: 'cngHankakuKana',
  add_decimal_point: 'addDecimalPoint',
  change_zenkaku: 'cngZenkaku',
  change_account_holder_zenkakuKana: 'cngAccountHolderZenkakuKana',
  change_account_holder_hankaku_kana: 'cngAccountHolderHankakuKana',
  fill_digit: 'fillDigit',
  serial_number: 'serialNumber',
  add_decimal_point_comma: 'addDecimalPointComma',
};

/**
 * フィールドマスタのタイプ
 */
export const fm_types = {
  text: 'TEXT',
  number: 'NUMBER',
  year: 'YEAR',
  month: 'MONTH',
  inputDate: 'INPUTDATE',
  pincode: 'PINCODE',
  password: 'PASSWORD',
  date: 'DATE',
  button: 'BUTTON',
  postcode: 'POSTCODE',
  tel: 'TEL',
  sei: 'SEI',
  mei: 'MEI',
  radio: 'RADIO',
  checkbox: 'CHECKBOX',
  select: 'SELECT',
  textarea: 'TEXTAREA',
  paragraph: 'PARAGRAPH',
  paragraph2: 'PARAGRAPH2',
  center_paragraph: 'CENTER_PARAGRAPH',
  center_alert_message: 'CENTER_ALERT_MESSAGE',
  link: 'LINK',
  image: 'IMAGE',
  items: 'ITEMS',
  business_date: 'BUSINESSDATE',
  after_specified_date: 'AFTERSPECIFIEDDATE',
  file: 'FILE',
  first_input: 'FIRST_INPUT',
  second_input: 'SECOND_INPUT',
  third_input: 'THIRD_INPUT',
  number_of_replacement_payments: 'NUMBER_OF_REPLACEMENT_PAYMENTS',
  datalist: 'DATALIST',
  first_text: 'FIRSTTEXT',
  second_text: 'SECONDTEXT',
  no_label_textarea: 'NOLABELTEXTAREA',
  no_label_checkbox: 'NOLABELCHECKBOX',
  shelf_heading: 'SHELFHEADING',
  clause: 'CLAUSE',
  pdf_viewer: 'PDFVIEWER',
  text_with_search: 'TEXT_WITH_SEARCH',
  file_help_msg: 'FILE_HELP_MSG',
  electronic_contract_button: 'ELECTRONIC_CONTRACT_BUTTON',
  account_type: 'ACCOUNT_TYPE',
  text_with_search_key: 'TEXT_WITH_SEARCH_KEY',
  text_with_search_value: 'TEXT_WITH_SEARCH_VALUE',
  send_back_button: 'SEND_BACK_BUTTON',
  overtime_principal_repayment_methods: 'OVERTIME_PRINCIPAL_REPAYMENT_METHODS',
  quantity: 'QUANTITY',
  unit: 'UNIT',
  date_all: 'DATE_ALL',
};

/**
 * 数値変換対象
 */
export const to_numeric_type = [fm_types.number, fm_types.year, fm_types.pincode];

/**
 * UTF文字コード（UTF-16 BE）
 */
export const utf_code = {
  zenkaku_numeric_start: 0xff10, // 全角数字の始点文字コード
  zenkaku_numeric_end: 0xff19, // 全角数字の終点文字コード
  zenkaku_numeric_convert: 0xfee0, // 全角数字→半角数字の変換用文字コード
  zenkaku_hiragana_start: 0x3041, // 全角ひらがなの始点文字コード
  zenkaku_hiragana_end: 0x3093, // 全角ひらがなの終点文字コード
  zenkaku_hiragana_convert: 0x0060, // 全角ひらがなの変換用文字コード
  hankaku_dakuten: 0xff9e, // 半角ｶﾅの濁点の文字コード
  hankaku_handakuten: 0xff9f, // 半角ｶﾅの半濁点の文字コード
};

/**
 * ダウンロード対象のファイル種別
 */
export const content_type = {
  pdf: 'application/pdf',
  csv: 'text/csv',
};
/**
 * 変換文字
 */
export const convert_char = {
  hankaku_kana: '｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝ ',
  hankaku_kana_dakuon_base: 'ｳｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾊﾋﾌﾍﾎ',
  hankaku_kana_handakuon_base: 'ﾊﾋﾌﾍﾎ',
  hankaku_kana_dakuten: 'ﾞ',
  hankaku_kana_handakuten: 'ﾟ',
  zenkaku_kana:
    '。「」、・ヲァィゥェォャュョッーアイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワン　',
  zenkaku_kana_dakuon: 'ヴガギグゲゴザジズゼゾダヂヅデドバビブベボ',
  zenkaku_kana_handakuon: 'パピプペポ',
  zenkaku_hiragana:
    '。「」、・をぁぃぅぇぉゃゅょっーあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわん　',
  zenkaku_hiragana_dakuon: 'ゔがぎぐげござじずぜぞだぢづでどばびぶべぼ',
  zenkaku_hiragana_handakuon: 'ぱぴぷぺぽ',
  hankaku_space: ' ',
  zenkaku_space: '　',
  hankaku_backslash: /\\/g,
  zenkaku_backslash: '￥',
  zenkaku_numeric_base: '１２３４５６７８９０',
  hankaku_numeric_base: '1234567890',
  zenkaku_alphabet_base:
    'ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚＡＢＣＤＥＦＧＨＩＪＫＭＬＮＯＰＱＲＳＴＵＶＷＸＹＺ',
  hankaku_alphabet_base: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKMLNOPQRSTUVWXYZ',
};

/**
 * HTTPステータスコード
 */
export const http_status = {
  ok: 200,
  created: 201,
};

/**
 * モジュール名
 */
export const module_name = {
  mypage_check: 'S040N001Check',
  mypage_open: 'S4000N001MypageOpen',
  form_output: 'S070N001FormOutput',
  mypage_agreement: 'S050N001Check',
};

/**
 * バリデーション用の結合文字列
 * Note : ボタン押下時のバリデーション対象がcheckbox、postcode、radioだった場合に使用
 */
export const valid_merge_index = '-0';

/**
 * スクロール位置調整用オプション
 */
export const scroll_option = {
  validation: -70,
  next_shelf: 0,
};

/**
 * 案件一覧に戻るボタンのメッセージ
 */
export const return_menu_option = {
  modal_title: '確認',
  modal_body: '案件一覧に戻ってよろしいですか？',
};

/*
 * pdfダウンロード時のwaitタイム(ミリ秒)
 */
export const download_wait_time = 3000;

// 本人確認書類の画像イメージの設定
export const compressor_option = {
  quality: 1,
  max_height: 1920,
  max_width: 1080,
  preview_max_height: 300,
  preview_max_width: 300,
};

// 本人確認書類のプレビュー画像イメージの設定
export const preview_option = {
  reduction_rate_pc: 0.7,
  reduction_rate_sp: 0.7,
};

export const file_type_error = {
  file: ['ファイルにはpdf,bmp,jpeg,jpg,png,gifタイプのファイルを指定してください。'],
};

export const file_upload_error = {
  file: ['ファイルアップロードに失敗しました'],
};

// ファイルアップロード ラベルの省略設定
export const file_upload_clamp_config = {
  length: 18,
  clamp_string: '...',
};

//入力支援(桁埋め)の追加文字列
export const assist_digit = '0000000000';

//テキストエリアのデフォルト行数
export const textarea_default_row = 3;

//案件一覧 検索パラメータの初期値
export const search_params_init = {
  first_name: '',
  last_name: '',
  kana_first_name: '',
  kana_last_name: '',
  status_from: '',
  status_to: '',
  birthday: '',
  reception_cd: '',
  reception_store: '',
  retailer: '',
  execution_store: '',
  pre_examination_date_from: '',
  pre_examination_date_to: '',
  pre_examination_result: '',
  examination_result: '',
  prefered_date_from: '',
  prefered_date_to: '',
};

//案件履歴 検索パラメータの初期値
export const reception_history_search_params_init = {
  from_update_at: '',
  to_update_at: '',
  update_user_type: new Array<KeyValue>(),
  update_name: '',
  status: '',
  item_name: '',
  item_old_value: '',
  item_new_value: '',
};

//ログ一覧 検索パラメータの初期値
export const log_search_params_init = {
  created_at_from_ymd: '',
  created_at_from_hour: '',
  created_at_from_minute: '',
  created_at_to_ymd: '',
  created_at_to_hour: '',
  created_at_to_minute: '',
  error_level: '',
  message_code: '',
  message: '',
  reception_cd: '',
  reception_sub_cd: '',
  operation: '',
  src_address: '',
};

// 営業日カレンダーの設定
export const business_day_calendar = {
  min_date: 3, // 選択可能な日付の最低日数
  max_year: 1, // 選択可能な日付の最大年数
};

// DatepickerJpの設定
export const datepicker_jp = {
  year_from: 11, // N年後の未来年を表示する
  year_to: 101, // N年前の過去年を表示する
};

// 案件一覧 projectオブジェクトから呼び出すデータのindexを指定する
export const project_list_staff_read_index = {
  reception_cd: 1, // 案件番号
  reception_id: 16, // 案件ID
  status: 17, // 案件ステータス
};

// マスク文字列
export const mask_string = '●';

//申込人案件一覧画面の商品概要のリンク
export const product_summary_link = '';

//ローディング画面非表示時のタイマー設定
export const loding_close_timmer = 5000;

//案件履歴画面ヘッダー初期値
export const header_info_init = {
  application_product: '',
  is_history: true,
  is_staff: true,
  reception_cd: '',
  status_code: 0,
  status_name: '',
  user_name: '',
};
// 時コントロール選択項目
export const hours = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
];

// 分コントロール選択項目
export const minutes = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '37',
  '38',
  '39',
  '40',
  '41',
  '42',
  '43',
  '44',
  '45',
  '46',
  '47',
  '48',
  '49',
  '50',
  '51',
  '52',
  '53',
  '54',
  '55',
  '56',
  '57',
  '58',
  '59',
];

/**
 * 住所検索ダイアログの表示メッセージ
 */
export const address_option = {
  title: '住所検索',
  undefined_body: '該当する郵便番号はありません。',
  auto_input_body: 'が自動入力されました。',
};

/**
 * 検索項目つきテキストボックスダイアログの表示メッセージ
 */
export const text_with_search_option = {
  title: '項目を選択してください',
};

/**
 * 住所検索ダイアログの初期値
 */
export const address_init = {
  form_name: '',
  value: '',
};

/**
 * 検索項目つきテキストボックスダイアログの初期値
 */
export const item_init = {
  name: '',
  value: '',
};

/**
 * 対応する郵便番号のindex値
 * first：array[0]
 * last：array[1]
 */
export const postcode_index = {
  first: 0,
  last: 1,
};

// 検索結果ダイアログの初期値
export const search_dialog_init = {
  is_confirm: false,
  details: [],
  show: false,
  title: '',
  body: '',
};

// 検索項目つきテキストボックスダイアログの初期値
export const text_with_search_dialog_init = {
  is_confirm: false,
  details: [],
  show: false,
  title: '',
  field_column_name: '',
};

// テンプレート一覧 templatesオブジェクトから呼び出すデータのindexを指定する
export const template_list_read_index = {
  template_id: 0, // テンプレートid
  status: 4, // ステータス
  item_id: 5, // 商品
  role_id: 6, //権限
};
// 案件一覧 検索パラメータの初期値
export const template_search_params_init = {
  item: '',
  role: '',
};

//入力支援(0埋め)の追加文字列
export const fill_digit = '0000000';

//入力支援(桁埋め)の追加文字列
export const serial_number_digit = '000000';
